import styled from '@emotion/styled';
import tw from 'twin.macro';

export const StyledSection = styled.section`
  ${tw`bg-ui-colours-ui1`}
`;

export const StyledGrid = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`grid`}
  ${tw`grid-cols-1`}
  ${tw`gap-4`}
  ${tw`px-2`}
  ${tw`py-4`}
  ${tw`last:pb-10`}

  ${tw`sm:px-0`}

  ${tw`lg:grid-cols-3`}
  ${tw`last:lg:pb-11`}
`;
